import React from 'react'

export function Arrow({
    size = 24,
    color = "black",
    transform = ""
}) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" transform={transform} xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" fill={color} d="M3 12.75H19.14L12 20L13 21L20.309 13.691C20.774 13.226 21 12.613 21 12C21 11.387 20.774 10.774 20.309 10.309L13 3L12 4L19.14 11.25H3V12.75Z"/>
        </svg>
    )
}

export function ArrowRight({
    size = 24,
    color = "black"
}) {
    return <Arrow size={size} color={color} transform=""/>
}

export function ArrowLeft({
    size = 24,
    color = "black"
}) {
    return <Arrow size={size} color={color} transform="scale(-1 -1)"/>
}
